import { createInterfaceId } from "@gitlab/needle";
//#region src/repository_service.ts
/**
* @deprecated Use RepositoryDiscoveryService instead.
*/
const RepositoryService = createInterfaceId("RepositoryService");
const RepositoryDiscoveryService = createInterfaceId("RepositoryDiscoveryService");
const IGNORED_DIRECTORY_NAMES = [
	"node_modules",
	"dist",
	".bundle",
	".idea",
	".vscode",
	"__pycache__",
	".mypy_cache",
	".pytest_cache",
	".tox",
	".venv"
];
//#endregion
export { RepositoryDiscoveryService as n, RepositoryService as r, IGNORED_DIRECTORY_NAMES as t };

//# sourceMappingURL=common_paths-B0_4d8JX.mjs.map